import moment from "moment";
import React, { Component, useEffect, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import AddEquipmentModal from "../../../modals/add-equipment-template/add-equipment-template";
import "react-confirm-alert/src/react-confirm-alert.css";
import "./equipment-template.scss";
import { DeleteEquipmentTemplate } from "../../../../api";
import Loader from "../../../loader/loader";
import SelectDropDown from "../../../shared/drop-down/drop-down";
import { getAlertPopUp } from "../../../helper/helper";

const filterType = "equipment";
class EquipmentTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAddTeamplateModel: false,
            searchValue: "",
            selectedTemplate: {},
            selectedTemplateName: "",
            selectedTemplateId: "",
        };
    }
    componentDidMount() {
        this.props.handleSearchKeyChange(this.state.searchValue, filterType);
    }

    handleShowModel = () => {
        this.setState(
            {
                selectedTemplate: undefined,
                selectedTemplateName: "",
                selectedTemplateId: "",
            },
            () => {
                this.setState({ showAddTeamplateModel: true });
            },
        );
    };

    handleKeyWordChange = (evt) => {
        this.setState({ searchValue: evt.target.value }, () => {
            this.props.handleSearchKeyChange(
                this.state.searchValue,
                filterType,
            );
        });
    };

    handleSearchClick = (evt) => {
        if (this.state.searchValue !== "")
            this.props.handleSearchKeyChange(
                this.state.searchValue,
                filterType,
            );
    };

    editTemplate(template) {
        const templateOptions = JSON.parse(template.template);
        this.setState(
            {
                selectedTemplate: templateOptions,
                selectedTemplateName: template.template_name,
                selectedTemplateId: template.id,
            },
            () => {
                this.setState({ showAddTeamplateModel: true });
            },
        );
    }

    handleTemplateDelete = (evt) => {
        confirmAlert({
            title: "Delete Template",
            message: "Are you sure you want to delete the template?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        this.deleteTemplate(evt);
                        this.setState({ searchValue: "" });
                    },
                },
                {
                    label: "No",
                },
            ],
        });
    };
    deleteTemplate(template) {
        DeleteEquipmentTemplate(template.id)
            .then((response) => {
                if (response.success) {
                    this.props.handleSearchKeyChange(
                        this.state.searchValue,
                        filterType,
                    );
                    const popup = {
                        title: "Success!",
                        html: "Record removed successfully",
                    };
                    getAlertPopUp(popup);
                } else {
                    const popup = {
                        title: "Error!",
                        html: response.message,
                        error: true,
                    };
                    getAlertPopUp(popup);
                }
            })
            .catch((error) => console.log(error));
    }

    render() {
        const { showAddTeamplateModel, searchValue } = this.state;
        const {
            isPcAdmin,
            userData,
            templateList,
            selected_org_id,
            selected_user_id,
        } = this.props;
        return (
            <>
                {showAddTeamplateModel === true && (
                    <AddEquipmentModal
                        showAddTeamplateModel={showAddTeamplateModel}
                        handleCloseModel={() =>
                            this.setState({ showAddTeamplateModel: false })
                        }
                        show={showAddTeamplateModel}
                        organization_id={selected_org_id}
                        GetEquipmentTemplateList={() =>
                            this.props.handleSearchKeyChange(
                                searchValue,
                                filterType,
                            )
                        }
                        selectedTemplate={this.state.selectedTemplate}
                        selectedTemplateName={this.state.selectedTemplateName}
                        selectedTemplateId={this.state.selectedTemplateId}
                        selected_user_id={selected_user_id}
                    />
                )}
                <div className="panel-heading" id="pannel-headingId">
                    <div className="header-search">
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                            }}
                        >
                            <input
                                value={searchValue}
                                type="text"
                                placeholder="Search Template"
                                name="search"
                                className="search-box"
                                onChange={(evt) =>
                                    this.handleKeyWordChange(evt)
                                }
                            />
                            <button
                                onClick={(e) => this.handleSearchClick(e)}
                                type="button"
                            >
                                <i className="fa fa-search"></i>
                            </button>
                        </form>
                        <div className="templete-dropdown-filter">
                            {isPcAdmin === true && (
                                <div className="org-dropdown">
                                    <SelectDropDown
                                        isSearchable={true}
                                        options={
                                            this.props.org_options
                                                ? this.props.org_options
                                                : []
                                        }
                                        name="filter_by_organization"
                                        placeholder="Search by organization"
                                        value={selected_org_id}
                                        handleChange={(selected) => {
                                            if (selected != null) {
                                                this.props.handleOrgChange(
                                                    selected.value,
                                                    filterType,
                                                );
                                            }
                                        }}
                                        clearValue={true}
                                        templateReset={() =>
                                            this.props.resetOrgValue(filterType)
                                        }
                                    />
                                </div>
                            )}
                            <div className="user-dropdown">
                                {(isPcAdmin === true ||
                                    userData.role == "admin") &&
                                    selected_org_id && (
                                        <SelectDropDown
                                            isSearchable={true}
                                            options={this.props.user_options}
                                            name="filter_by_user"
                                            placeholder="Search by user"
                                            value={selected_user_id}
                                            handleChange={(selected) => {
                                                if (selected != null) {
                                                    this.props.handleUserChange(
                                                        selected.value,
                                                        filterType,
                                                    );
                                                }
                                            }}
                                            clearValue={true}
                                            templateReset={() =>
                                                this.props.resetUserValue(
                                                    filterType,
                                                )
                                            }
                                        />
                                    )}
                            </div>
                        </div>
                    </div>
                    <div className="d-flex">
                        <button
                            className="orgbtn"
                            onClick={() => this.handleShowModel()}
                        >
                            <i className="fa fa-create"></i> Add Template
                        </button>
                    </div>
                </div>

                <div className="table-organizations table-templates">
                    {templateList && templateList.length > 0 ? (
                        <table
                            className="table table-striped table-responsive template-list"
                            id="template-index-table"
                        >
                            <thead>
                                <tr>
                                    <th className="TemplateTitle">
                                        Template Name
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {templateList.map((template, index) => (
                                    <tr key={"tr" + index}>
                                        <td className="TemplateName">
                                            <div className="org-full-name">
                                                <h4>
                                                    {template.template_name}
                                                </h4>
                                            </div>
                                        </td>
                                        <td className="addresidual template-add-delete">
                                            <span
                                                onClick={(evt) => {
                                                    this.editTemplate(template);
                                                }}
                                            >
                                                Edit
                                            </span>

                                            {isPcAdmin === true ||
                                            userData.role == "admin" ||
                                            userData.id ==
                                                template.created_by ? (
                                                <span
                                                    onClick={(evt) =>
                                                        this.handleTemplateDelete(
                                                            template,
                                                        )
                                                    }
                                                    className="addresidualIMG"
                                                >
                                                    <img src="/images/delet.svg " />
                                                </span>
                                            ) : (
                                                <span className="addresidualIMG cursor-not-allowed">
                                                    <img src="/images/delet.svg " />
                                                </span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : !this.props.showSpinner ? (
                        <p className="no-data text-center">
                            {" "}
                            No Templates found
                        </p>
                    ) : (
                        ""
                    )}
                </div>
                {this.props.showSpinner ? (
                    <div className="equipment-loader">
                        <Loader />
                    </div>
                ) : (
                    ""
                )}
            </>
        );
    }
}

export default EquipmentTemplate;
